// config.js
export const BASE_URL = 'https://newomkatech.omkatech.in/api';